import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { Market } from '@awesome-cordova-plugins/market/ngx';
import { environment } from '../../../../environments/environment';
import { App } from '@capacitor/app';
@Component({
  selector: 'app-modal-atualizacao-app',
  templateUrl: './modal-atualizacao-app.page.html',
  styleUrls: [ './modal-atualizacao-app.page.scss' ],
})
export class ModalAtualizacaoAppPage implements OnInit {

  BUNDLE_APP = environment.bundleId;
  URL_APP = environment.urlAtualizacao;

  isHybrid;

  constructor(private modalController: ModalController,
              private router: Router,
              private market: Market,
              private platform: Platform
  ) {
  }

  ngOnInit() {
    this.isHybrid = this.platform.is('hybrid');
  }

  async abrirLoja() {
    if (this.isHybrid) {
      const deviceInfo = await App.getInfo();
      // if (deviceInfo.appId !== this.BUNDLE_APP) {
      if (this.BUNDLE_APP === 'br.gov.mma.monitorar') {
        await this.market.open(deviceInfo.id);
      } else {
        open(this.URL_APP);
      }
    } else {
      window.location.reload();
    }
  }
}
